import { useQuery } from "@tanstack/react-query";
import { fetchSurveyCoffeeKey } from ".";


export const useSurveyCoffeeKeyQuery = (coffeeKey) => {
    return useQuery({
        queryKey: ["coffe-assessment-item-result", coffeeKey],
        queryFn: () => fetchSurveyCoffeeKey(coffeeKey),
        select: (response) => {
            return response.data || {};
        },
        onError: (error) => {
            console.error("Error fetching coffe assessment item result API contracts:", new Date().toISOString(), error);
        },
        staleTime: 1000 *  process.env.REACT_APP_USE_QUERY_STALE_TIME, // env Value default(1)
        refetchOnWindowFocus: false,
        enabled: !(coffeeKey === undefined || coffeeKey === null || coffeeKey === ''),
    });
};